export default "__VITE_ASSET__DokDOSyE__"